import { gql } from '@apollo/client';

const VERIFY_LOGIN_FIELDS = `
  outcome
  session {
    subjectId
    sessionToken
  }
  subjects {
    subjectId
    displayName
  }
  refusal {
    reason
    retryAt
  }
`;

export const REQUEST_LOGIN_LINK = gql`
  mutation VerificationToken_requestLink($input: RequestLoginLinkInput!) {
    VerificationToken_requestLink(input: $input) {
      outcome
      requestId
      retryAt
    }
  }
`;

export const VERIFY_LINK_TOKEN = gql`
  mutation VerificationToken_verifyLinkToken($input: VerifyLinkTokenInput!) {
    VerificationToken_verifyLinkToken(input: $input) {
      ${VERIFY_LOGIN_FIELDS}
    }
  }
`;

export const VERIFY_CODE_TOKEN = gql`
  mutation VerificationToken_verifyCodeToken($input: VerifyCodeTokenInput!) {
    VerificationToken_verifyCodeToken(input: $input) {
      ${VERIFY_LOGIN_FIELDS}
    }
  }
`;
